import React from 'react';

type OperatingSystem = 'macOS' | 'Other' | null;

type UseDetectOs = {
  os: OperatingSystem;
  isMacOS: boolean;
};

export function useDetectOS(): UseDetectOs {
  const [os, setOS] = React.useState<OperatingSystem>(null);

  React.useEffect(() => {
    if (global?.window) {
      // @ts-ignore
      if (window.navigator.userAgentData) {
        // @ts-ignore
        const { platform } = window.navigator.userAgentData;
        if (platform === 'macOS') {
          setOS('macOS');
        } else {
          setOS('Other');
        }
      } else {
        window.navigator.userAgent.indexOf('Mac') != -1
          ? setOS('macOS')
          : setOS('Other');
      }
    }
  }, []);

  return {
    os,
    isMacOS: os === 'macOS'
  };
}
